import { render } from "./SeparatorBar.vue?vue&type=template&id=de16b174&scoped=true&ts=true"
import script from "./SeparatorBar.vue?vue&type=script&lang=ts"
export * from "./SeparatorBar.vue?vue&type=script&lang=ts"

import "./SeparatorBar.vue?vue&type=style&index=0&id=de16b174&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de16b174"]])

export default __exports__